/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Meta_Mode_NoteInputs */



/**
* | output |
* | --- |
* | "This mode applies to all the child leagues' events. Each child league's own standings may use another mode." |
*
* @param {League_Meta_Mode_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_meta_mode_note = /** @type {((inputs?: League_Meta_Mode_NoteInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Meta_Mode_NoteInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce mode s'applique à tous les tournois des ligues enfants. Le classement propre de chaque ligue enfant peut utiliser un autre mode.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este modo se aplica a todos los torneos de las ligas hijas. La clasificación propia de cada liga hija puede usar otro modo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Este modo vale para todos os torneios das ligas filhas. A classificação própria de cada liga filha pode usar outro modo.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questa modalità vale per tutti i tornei dei campionati figli. La classifica propria di ogni campionato figlio può usare un'altra modalità.")
	return /** @type {LocalizedString} */ ("This mode applies to all the child leagues' events. Each child league's own standings may use another mode.")
});